module.exports = __webpack_public_path__ + "img/receive_success.469a8c84.png";